import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';
import { AppConfig } from '../../config/app.config';

import { Storage } from '@ionic/storage';
import { Http, Headers } from '@angular/http';
import { LoginPage } from '../../pages/login/login';
import { EventEmitter } from 'events';
import { CustomerGroup } from '../../models/customer';

export class Credentials {
  constructor(email?: string, password?: string) {
    this.email = email;
    this.password = password;
  }

  email: string;
  password: string;
}

export class RegisterModel {
  constructor(email?: string, password?: string, firstname?: string, lastname?: string) {
    this.email = email;
    this.password = password;
    this.firstname = firstname;
    this.lastname = lastname;
  }

  email: string;
  password: string;
  firstname: string;
  lastname: string;
  phone: string;
}

const TOKEN_KEY = 'TOKEN'

@Injectable()
export class LoginProvider {

  loginStateEventEmitter = new EventEmitter();

  constructor(private http: Http,
    private storage: Storage, 
    private config: AppConfig) {
  }

  private customerGroup: CustomerGroup;
  public isAnonymousSession = false;

  /**
  * Returns true if the email and password are correct.
  */
  public async login(credentials?: Credentials): Promise<boolean> {
    let headers = new Headers();
    let form = new FormData();
    if (credentials) {
      form.append('store_uuid', this.config.companyId);
      form.append('username', credentials.email);
      form.append('password', credentials.password);
    }
    return this.http.post(this.config.domain + '/api/login', '', {
      body: form,
      headers: headers
    }).map(async x => {
      var token = x.json()["token"] as string;
      var isValid = token.length > 0;
      if (isValid) {
        this.isAnonymousSession = false;
        await this.storage.set(TOKEN_KEY, token);
        return isValid;
      }
    }).toPromise();
  }

  public async register(model: RegisterModel): Promise<boolean> {
    let headers = new Headers();
    let form = new FormData();
    form.append('username', model.email);
    form.append('password', model.password);
    form.append('first_name', model.firstname);
    form.append('last_name', model.lastname);
    form.append('store_uuid', this.config.companyId);
    return this.http.post(this.config.domain + '/api/register', '', {
      body: form,
      headers: headers
    }).map(async x => {
      var token = x.json()["token"] as string;
      var isValid = token.length > 0;
      if (isValid) {
        this.logout();
        return true;
      }
      return false;
    }).toPromise();
  }
  
  
  public async sendForgotPSWDMail(model: RegisterModel): Promise<boolean> {
    let headers = new Headers();
    let form = new FormData();
    form.append('username', model.email);
    form.append('store_uuid', this.config.companyId);
    return this.http.post(this.config.domain + '/api/forgotpassword', '', {
      body: form,
      headers: headers
    }).map(async x => {
      var message = x.json()["message"] as string;
      var conditions = ['not a valid', 'error'];
      var isValid = !conditions.some(el => message.includes(el));
      if (isValid) {
        this.logout();
        return true;
      }
      return false;
    }).toPromise();
  }



  public async startAnonymousSession(){
    this.isAnonymousSession = true;
  }

  public async isAuthenticated(): Promise<boolean> {
    return await this.getToken().then(token => token !=null && token.length > 0);
  }

  public async getToken(): Promise<string> {
    var x = await this.storage.get(TOKEN_KEY);
    if(x == null) return "";
    return x;
  }

  /**
  * Logs out the user by removing api key.
  */
  public async logout() {
    await this.storage.remove(TOKEN_KEY);
    this.loginStateEventEmitter.emit("LoggedOut");
  }

  public async quitAnonymousSession(){
    this.isAnonymousSession = false;
    this.loginStateEventEmitter.emit("LoggedOut");
  }

  public getCustomerGroup(): CustomerGroup {
    return this.customerGroup;
  }
}


// WEBPACK FOOTER //
// ./src/providers/login/login.ts